
/* eslint-disable vue/component-api-style */
import AlgoliaRecipes from '~/components/_next/template/recipes/AlgoliaRecipes.vue';
import { AisInstantSearchSsr, createServerRootMixin } from 'vue-instantsearch';
import _renderToString from 'vue-server-renderer/basic';
import algoliasearch from 'algoliasearch/lite.js';
import { RECIPE_INDEX } from '~/constants/algoliaIndex';

function renderToString(app) {
  return new Promise((resolve, reject) => {
    _renderToString(app, (err, res) => {
      if (err) reject(err);
      resolve(res);
    });
  });
}
const searchClient = algoliasearch(process.env.ALGOLIA_APP_ID, process.env.ALGOLIA_APP_KEY);
export default {
  components: {
    AisInstantSearchSsr,
    AlgoliaRecipes,
  },
  mixins: [
    createServerRootMixin({
      searchClient,
      indexName: RECIPE_INDEX.es,
      future: {
        preserveSharedStateOnUnmount: false,
      },
    }),
  ],
  serverPrefetch() {
    /* eslint-disable-next-line vue/no-undef-properties */
    return this.instantsearch
      .findResultsState({
        component: this,
        renderToString,
      })
      .then((algoliaState) => {
        this.$ssrContext.nuxt.algoliaState = algoliaState;
      });
  },
  head() {
    return {
      link: [
        {
          rel: 'stylesheet',
          href: 'https://cdn.jsdelivr.net/npm/instantsearch.css@8.5.1/themes/satellite-min.css',
        },
      ],
    };
  },
  beforeMount() {
    const results = this.$nuxt?.context?.nuxtState?.algoliaState || window?.__NUXT__?.algoliaState;
    if (results) {
      this.instantsearch.hydrate(results);
      if (this?.$nuxt?.context?.nuxtState) {
        delete this.$nuxt.context.nuxtState.algoliaState;
      }
      if (typeof window !== 'undefined' && window.__NUXT__) {
        delete window.__NUXT__.algoliaState;
      }
    }
  },
};
